<div
  class="sp-width__full sp-height__full sp-page__with-navbar"
  [ngClass]="getNavbarClass()">
  <app-navbar
    class="sp-hidden__before-lg"
    [current_nav_item]="current_nav_item"
    [navbar_status]="navbar_status"
    (status_change)="onNavbarStatusChange($event)"></app-navbar>

  <div class="sp-position__relative">
    <app-toolbar
      [current_nav_item]="current_nav_item"
      [width_class]="getToolbarWidthClass()"></app-toolbar>

    <div class="sp-home__grid sp-grid__gap sp-page__with-absolute-toolbar sp-padding__x2">
      <app-home-evaluation-companies (refresh)="onCompaniesRefresh()"></app-home-evaluation-companies>

      <app-home-stores></app-home-stores>

      <app-home-signature-companies (refresh)="onCompaniesRefresh()"></app-home-signature-companies>

      <app-home-orders></app-home-orders>

      <app-home-acceptance-companies (refresh)="onCompaniesRefresh()"></app-home-acceptance-companies>

      <app-home-buyers></app-home-buyers>
    </div>
  </div>
</div>
